import { getAuthenticatorSelectedChannel } from '../../../utils/widget-facade';
import OktaVerifyEnrollOieBaseCustomizer from '../base';

export default class EnrollPollBaseCustomizer extends OktaVerifyEnrollOieBaseCustomizer {
  protected selectedChannel = getAuthenticatorSelectedChannel();
  async shouldCustomize() {
    return (await super.shouldCustomize()) && this.context.formName === 'enroll-poll';
  }
}
